module.exports = __webpack_public_path__ + "4f24b00df06bcc9666f72fa0a8ed58b1.fbx";